function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import mediaQueries from "../mediaQuery";
import { DEVICES } from "../mediaQuery/consts";
import getViewportGridStyles from "./helpers/getViewportGridStyles";
import isDefined from "../../Stack/helpers/isDefined";
var StyledGrid = styled(function (_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      dataTest = _ref2.dataTest;
  return React.createElement("div", {
    className: className,
    "data-test": dataTest
  }, children);
}).withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "cj22hw-0"
})(["", ";& > *{display:block;}"], function (props) {
  return DEVICES.map(function (viewport, index, devices) {
    return viewport in mediaQueries ? mediaQueries[viewport](css(["", ";"], isDefined(props[viewport]) && getViewportGridStyles({
      viewport: viewport,
      index: index,
      devices: devices
    }))) : viewport === "smallMobile" && css(["", ";"], getViewportGridStyles({
      viewport: viewport,
      index: index,
      devices: devices
    }));
  });
});
StyledGrid.defaultProps = {
  theme: defaultTheme
};

var Grid = function Grid(_ref) {
  var inline = _ref.inline,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? "1fr" : _ref$rows,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? "1fr" : _ref$columns,
      gap = _ref.gap,
      rowGap = _ref.rowGap,
      columnGap = _ref.columnGap,
      maxWidth = _ref.maxWidth,
      children = _ref.children,
      dataTest = _ref.dataTest,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? "div" : _ref$element,
      props = _objectWithoutProperties(_ref, ["inline", "rows", "columns", "gap", "rowGap", "columnGap", "maxWidth", "children", "dataTest", "element"]);

  var smallMobile = {
    inline: inline,
    rows: rows,
    columns: columns,
    gap: gap,
    rowGap: rowGap,
    columnGap: columnGap,
    maxWidth: maxWidth
  };
  return React.createElement(StyledGrid, _extends({
    smallMobile: smallMobile,
    "data-test": dataTest,
    as: element
  }, props), children);
};

export default Grid;